import { requiredParam } from "@utils/func";

const saveState = ({
  key = requiredParam("key"),
  state = requiredParam("state"),
} = {}) => {
  return window.localStorage.setItem(key, JSON.stringify(state));
};

export { saveState };
